import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import server from "../../server";

const hardCoded = [
  {
    timestamp: "2025-04-05T12:30:45.123Z",
    orderId: "ORD123456",
    productId: "PROD987654",
    employeeId: "EMP112233",
    scannedCode: "8901234567890",
    message: "No valid product batches found for the scanned code",
  },
];
const ScanErrorLogs = () => {
  const location = useLocation();
  const { orderId } = location.state;
  const [logs, setLogs] = useState([]);
  const [filters, setFilters] = useState({
    orderId: orderId || "",
    employeeId: "",
    productId: "",
    scannedCode: "",
  });

  const fetchLogs = async () => {
    try {
      const params = {};
      Object.keys(filters).forEach((key) => {
        if (filters[key]) params[key] = filters[key];
      });

      const result = await axios.get(`${server}/logs/get-scan-logs`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setLogs(result.data.logs || []);
    } catch (err) {
      console.error("Error fetching logs:", err);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <Box p={4}>
      <Typography variant="h5" gutterBottom>
        Scan Error Logs
      </Typography>
      <Box display="flex" gap={2} flexWrap="wrap" mb={3}>
        {filters.orderId && (
          <Typography variant="body1">
            <strong>Order ID:</strong> {filters.orderId}
          </Typography>
        )}
        {filters.employeeId && (
          <Typography variant="body1">
            <strong>Employee ID:</strong> {filters.employeeId}
          </Typography>
        )}
        {filters.productId && (
          <Typography variant="body1">
            <strong>Product ID:</strong> {filters.productId}
          </Typography>
        )}
        {filters.scannedCode && (
          <Typography variant="body1">
            <strong>Scanned Code:</strong> {filters.scannedCode}
          </Typography>
        )}
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Timestamp</strong>
              </TableCell>
              <TableCell>
                <strong>Order ID</strong>
              </TableCell>
              <TableCell>
                <strong>Product ID</strong>
              </TableCell>
              <TableCell>
                <strong>Employee ID</strong>
              </TableCell>
              <TableCell>
                <strong>Scanned Code</strong>
              </TableCell>
              <TableCell>
                <strong>Error Message</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log, index) => (
              <TableRow key={index}>
                <TableCell>
                  {new Date(log.timestamp).toLocaleString()}
                </TableCell>
                <TableCell>{log.orderId || "-"}</TableCell>
                <TableCell>{log.productId || "-"}</TableCell>
                <TableCell>{log.employeeId || "-"}</TableCell>
                <TableCell>{log.scannedCode || "-"}</TableCell>
                <TableCell>{log.message || "-"}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No logs found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ScanErrorLogs;
